import aiTextSagas from '@/sagas/aiText';
import brandColors from '@/sagas/brandColors';
import campaigns from '@/sagas/campaigns';
import contacts from '@/sagas/contacts';
import customFields from '@/sagas/customFields';
import dashboardSeenNotificationsSagas from '@/sagas/dashboardSeenNotifications';
import dashboardSettingsSagas from '@/sagas/dashboardSettings';
import deviceDetails from '@/sagas/deviceDetails';
import domain from '@/sagas/domain';
import exports from '@/sagas/export';
import formCreatorSagas from '@/sagas/formCreator';
import landingPageCreatorSagas from '@/sagas/landingPageCreator';
import formList from '@/sagas/formList';
import geography from '@/sagas/geography';
import landingPageList from '@/sagas/landingPageList';
import lists from '@/sagas/lists';
import mergeFieldsSagas from '@/sagas/mergeFields';
import onboardingSurvey from '@/sagas/onboardingSurvey';
import prebuildModulesSagas from '@/sagas/prebuildModules';
import rawEditorSagas from '@/sagas/rawEditor';
import segments from '@/sagas/segments';
import templateEditor from '@/sagas/templateEditor';
import templateList from '@/sagas/templateList';
import validEmails from '@/sagas/validEmails';
import landingPageSubdomainSagas from '@/sagas/landingPageSubdomain'
export default [
    ...formList,
    ...deviceDetails,
    ...contacts,
    ...campaigns,
    ...landingPageList,
    ...exports,
    ...lists,
    ...segments,
    ...geography,
    ...validEmails,
    ...domain,
    ...templateList,
    ...rawEditorSagas,
    ...onboardingSurvey,
    ...templateEditor,
    ...brandColors,
    ...dashboardSettingsSagas,
    ...prebuildModulesSagas,
    ...aiTextSagas,
    ...dashboardSeenNotificationsSagas,
    ...customFields,
    ...formCreatorSagas,
    ...mergeFieldsSagas,
    ...landingPageCreatorSagas,
    ...landingPageSubdomainSagas
];
